export function clampStringToMaxLength(value: string, maxLength: number): string {
  if (!Number.isFinite(maxLength) || maxLength < 0) return value;
  if (value.length <= maxLength) return value;
  return value.slice(0, maxLength);
}

export function formatCharacterCountHint(currentLength: number, maxLength: number): string {
  const safeMax = Number.isFinite(maxLength) && maxLength >= 0 ? maxLength : 0;
  const shown = Math.min(Math.max(0, currentLength), safeMax);
  return `${shown}/${safeMax} characters`;
}

export function exceedsMaxLength(value: string, maxLength: number): boolean {
  if (!Number.isFinite(maxLength) || maxLength < 0) return false;
  return value.length > maxLength;
}

export function shortcodeMaxLengthError(value: string, maxLength: number): string {
  const t = value.trim();
  if (!t) return "";
  return exceedsMaxLength(t, maxLength) ? `Shortcode must be at most ${maxLength} characters.` : "";
}

export function categoryEntityShortcodeMaxLengthError(value: string, maxLength: number): string {
  return shortcodeMaxLengthError(value, maxLength);
}
